import Modal from 'react-modal';
import { palette } from "../../../assets/theme/theme";
import CustomButtonSimple from "../../../components/CustomMiscellaneous/CustomButtonSimple";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        display: 'flex',
        transform: 'translate(-50%, -50%)',
        overflow: 'auto',
        justifyContent: 'center'
    },
};


export function ConfirmationModal({ text, onConfirm, onCancel, isOpen } : {text: string, onConfirm: Function, onCancel: Function, isOpen: boolean}) {

    return (<Modal style={customStyles} isOpen={isOpen}>
        <div>
        <div style={{justifyContent: 'center', width:'100%', margin: 20}}>
            <span>
                {text}
            </span>
        </div>
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <CustomButtonSimple color={palette.green} text={"Confirmar"} onClick={onConfirm}></CustomButtonSimple>
            <CustomButtonSimple color={palette.red} text={"Cancelar"} onClick={onCancel}></CustomButtonSimple>

        </div>
        </div>
    </Modal>)


}